<template>
  <vue-bootstrap-typeahead
    v-model="productAlias"
    :data="suggestions"
    :minMatchingChars="1"
  />
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue';

export default {
  name: 'ProtoItemAliasInput',

  components: {
    VueBootstrapTypeahead,
  },

  props: {
    value: {
      default: '',
    },
  },

  data() {  
    return {
      productAlias: this.value,
      suggestions: [],
    };
  },

  watch: {
    productAlias(newProductAlias) {
      this.$emit('input', newProductAlias);

      HTTP.get(
        '/proto_item_aliases/find',
        {
          params: {
            q: newProductAlias
          }
        }
      )
      .then(response => {
        const aliases = [];
        for(var i = 0; i < response.data.data.length; ++i) {
          const alias = response.data.data[i];
          aliases.push(alias);
        }
        this.suggestions = aliases;
      })
      .catch(e => {
        notifier.showError(e.response.data);
      })
    },
  },
};
</script>
